"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ECategoryWager = exports.ECasinoCategoryIds = void 0;
var ECasinoCategoryIds;
(function (ECasinoCategoryIds) {
    ECasinoCategoryIds[ECasinoCategoryIds["WagerSubCategoryTournament"] = -2] = "WagerSubCategoryTournament";
    ECasinoCategoryIds[ECasinoCategoryIds["WagerSubCategoryBonus"] = -1] = "WagerSubCategoryBonus";
    ECasinoCategoryIds[ECasinoCategoryIds["Wager"] = -1] = "Wager";
    ECasinoCategoryIds[ECasinoCategoryIds["Crash"] = 1] = "Crash";
    ECasinoCategoryIds[ECasinoCategoryIds["Slots"] = 2] = "Slots";
    ECasinoCategoryIds[ECasinoCategoryIds["Casino"] = 3] = "Casino";
    ECasinoCategoryIds[ECasinoCategoryIds["Turbo"] = 10] = "Turbo";
    ECasinoCategoryIds[ECasinoCategoryIds["Popular"] = 99] = "Popular";
    ECasinoCategoryIds[ECasinoCategoryIds["SubSlotsNew"] = 101] = "SubSlotsNew";
    ECasinoCategoryIds[ECasinoCategoryIds["PopularSubCategory"] = 102] = "PopularSubCategory";
    ECasinoCategoryIds[ECasinoCategoryIds["SubSlotsTop"] = 104] = "SubSlotsTop";
    ECasinoCategoryIds[ECasinoCategoryIds["SubGameShow"] = 124] = "SubGameShow";
})(ECasinoCategoryIds || (exports.ECasinoCategoryIds = ECasinoCategoryIds = {}));
var ECategoryWager;
(function (ECategoryWager) {
    ECategoryWager[ECategoryWager["Bonus"] = 1] = "Bonus";
    ECategoryWager[ECategoryWager["Tournament"] = 2] = "Tournament";
})(ECategoryWager || (exports.ECategoryWager = ECategoryWager = {}));
